import { TemplateElement } from '../../01-base/TemplateElement';
import style from './ClockElement.css';

class ClockElement extends TemplateElement {
    constructor() {
        super(null, { autoRender: true, styles: [style] });
    }

    hooks() {
        return {
            connected: () => {
                this.hours = this.hours > 12 ? this.hours - 12 : this.hours;

                this.minutes = this.minutes * 60;
                this.hours = this.hours * 3600 + this.minutes;

                this.$refs.minuteHand.setAttribute('transform', 'rotate(' + 360 * (this.minutes / 3600) + ',192,192)');
                this.$refs.hourHand.setAttribute('transform', 'rotate(' + 360 * (this.hours / 43200) + ',192,192)');
            },
        };
    }

    template() {
        return `
            <div class="clock global-styles">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 384 384">
                  <circle fill="white" stroke="#ff6400" stroke-width="12" cx="192" cy="192" r="184"/>
                  <line ref="hourHand" fill="none" stroke="#ff6400" stroke-width="12" stroke-miterlimit="10" x1="192" y1="192" x2="192" y2="100"/>
                  <line ref="minuteHand" fill="none" stroke="#ff6400" stroke-width="12" stroke-miterlimit="10" x1="192" y1="192" x2="192" y2="55"/>
                </svg>
            </div>
        `;
    }

    properties() {
        return {
            minutes: 0,
            hours: 0,
        };
    }
}

customElements.define('clock-element', ClockElement);
